export default {"src":"/_next/static/media/Design-stats-rafiki.dea9701f.svg","height":328,"width":440};